import User from '@/app/shared/domain/interfaces/User';
import BrowserRepository from '../../domain/BrowserRepository';
import DependencyInjection from '../provider/DependencyInjection';

const USER_KEY = 'user';

type UserManager = {
    insert: (user: User) => void,
    get: () => User,
    remove: () => void,
}

export default () : UserManager => {
    const browserRepository = DependencyInjection.inject('browserRepository') as BrowserRepository;

    const insert = (user: User): void => {
        browserRepository.insert(USER_KEY, user);
    };

    const get = (): User => {
        return browserRepository.get(USER_KEY) ?? new Error('User not found');
    };

    const remove = (): void => {
        browserRepository.remove(USER_KEY);
    };

    return {
        insert,
        get,
        remove,
    };
};
